<template>
    <img
        :src="src"
        :style="{ backgroundColor: background }"
        :class="$style.avatar"
        alt=""
        loading="lazy"
    />
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { AVATAR_COLORS, AVATAR_PALETTE } from './colors'

const props = defineProps<{ avatar: number; color?: number }>()

const avatars = import.meta.webpackContext('@/assets/avatars', { recursive: false, regExp: /\.webp$/i })

const background = computed(() => AVATAR_PALETTE[props.color ?? AVATAR_COLORS[props.avatar] ?? 0])
const src = computed(() => avatars(`./128x128-${props.avatar}.webp`) as string)
</script>
<style module>
.avatar {
    display: block;
    width: 32px;
    aspect-ratio: 1;
    border-radius: 50%;
}
</style>
